import Dexie from 'dexie'

export const db = new Dexie('hileiadb')

/**
不可索引的值类型
boolean
undefined
Object
null
可索引的值类型
string
number
Date
Arrays of strings, numbers, Dates or a mix of those.
ArrayBuffer (IndexedDB 2.0 only)
Typed arrays (IndexedDB 2.0 only)
 */

// 不做索引的不需要出现在 value 字符串中
db.version(6).stores({
  userPreferences: 'uid, resolution',
  // 会议通知， updateAt用于排序
  cocNotify: '++uKey, conferenceId, belongUser, updateAt, isReading', // {beginTime, endTime, actType, operator, theme, conferenceId, notifyType, conferenceState, confirmStatus, attendStatus, hostIsMe, updateAt, belongUser}
  // 系统通知
  sysNotify: '++uKey, &belongUser'
})
